<!--<div class="top-content">
    <div>
        <div class="top-container">
            <div>
                <a routerLink="/home"><div class="logo"></div></a>
            </div>
            <div>
                <h1>Enrollment Portal</h1>
            </div>
        </div>
    </div>
</div>-->

        <div class="container contactus">
            <div class="inner-container">
                <div class="row">
                    <div class="col-24">
                        <h1>Contact Us</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div [innerHtml]="contactcontent | safeHtml"></div>
                    </div>
                </div>
            </div>
        </div>
 